import { TradingOffer } from 'types/TradingOffer';
import { Partner, PartnerAddress } from 'types';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';
import { PublisherPartner } from '../types/PublishTradingOfferModalContextType';

type TradingOfferDraft = Partial<TradingOffer> & { className: string };

const emptyAddress = (): Partner['address'] => ({
  line1: '',
  zip: '',
  city: '',
  state: '',
  country: '',
});

const normalizeAddress = (
  addr?: Partial<PartnerAddress> | null
): Partner['address'] =>
  addr
    ? {
        line1: addr.line1 || '',
        zip: addr.zip || '',
        city: addr.city || '',
        state: addr.state || '',
        country: addr.country || '',
      }
    : emptyAddress();

const partnerIdFromOffer = (offer: TradingOfferDraft): string | undefined => {
  const { partner } = offer;
  if (!partner) return undefined;
  if (typeof partner === 'string') return partner;
  return partner._id;
};

export const buildInitialPublisherPartner = (
  publisherPartnerProp: PublisherPartner | null | undefined,
  tradingOffer: TradingOfferDraft
): PublisherPartner | null => {
  if (publisherPartnerProp) {
    return {
      ...publisherPartnerProp,
      address: normalizeAddress(publisherPartnerProp.address),
    };
  }

  const partnerId = partnerIdFromOffer(tradingOffer);
  if (!partnerId) return null;

  return {
    _id: partnerId,
    name: '',
    cif: '',
    email: '',
    phone: '',
    bankAccountNumber: '',
    address: emptyAddress(),
  };
};

export const mapPartnerOptionToPartialPartner = (
  selectedPartnerId: string,
  option: CustomAsyncSelectOption | null
): Partial<Partner> | null => {
  if (!selectedPartnerId) return null;

  if (option && option.value === selectedPartnerId) {
    return {
      _id: selectedPartnerId,
      name: option.name || '',
      cif: option.cif || '',
      email: option.email || '',
      phone: '',
      bankAccountNumber: '',
      address: normalizeAddress(option.address),
    };
  }

  return {
    _id: selectedPartnerId,
    name: '',
    cif: '',
    email: '',
    phone: '',
    bankAccountNumber: '',
    address: emptyAddress(),
  };
};
